import React from "react";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import GenieSkeleton from "../genie-skeleton/GenieSkeleton";

interface GenieTableLoadProps {
  rowCount: number;
  columnCount: number;
  sx?: object;
}

function GenieTableLoad({ rowCount, columnCount, sx }: GenieTableLoadProps) {
  const rows = Array.from(Array(rowCount), (_, i) => i + 1);
  const columns = Array.from(Array(columnCount), (_, i) => i + 1);
  return (
    <Table sx={sx}>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row}>
            {columns.map((column) => (
              <TableCell key={column}>
                <GenieSkeleton width={"100%"} height={32} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default GenieTableLoad;
